/* eslint-disable */


/**
 * Create styles for `<TermsPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<TermsPage />` styles
 */
const termsPageStyles = ({ theme }) => ({
  root: {
    [`-webkit-overflow-scrolling`]: `touch`,
    height: `100%`,
    overflowY: `auto`,
  },
});

export default termsPageStyles;
